import { ref, watch } from 'vue'

const STORAGE_KEY = 'woot_theme'
const darkMode = ref(localStorage.getItem(STORAGE_KEY) === 'dark')

function applyTheme(dark: boolean) {
  document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
}

applyTheme(darkMode.value)

watch(darkMode, (val) => {
  localStorage.setItem(STORAGE_KEY, val ? 'dark' : 'light')
  applyTheme(val)
})

export function useTheme() {
  function toggleTheme() {
    darkMode.value = !darkMode.value
  }
  return { darkMode, toggleTheme }
}
